// ===================================================
// File: src/components/Toast/Toast.jsx
// ===================================================
import { useState, useEffect } from 'react';

const Toast = ({ 
  id,
  title = "Notification", 
  message = "This is a toast message.",
  type = "success", // success, danger, warning, info, primary, secondary
  icon = "fas fa-check-circle",
  duration = 5000,
  onClose
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(id), 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, id, onClose]);

  const getToastClass = (toastType) => {
    const classes = {
      success: "bg-success text-white",
      danger: "bg-danger text-white",
      warning: "bg-warning text-dark",
      info: "bg-info text-white", 
      primary: "bg-primary text-white",
      secondary: "bg-secondary text-white"
    };
    return classes[toastType] || "bg-primary text-white";
  };

  const getIconByType = (toastType) => {
    const icons = {
      success: "fas fa-check-circle",
      danger: "fas fa-exclamation-circle",
      warning: "fas fa-exclamation-triangle",
      info: "fas fa-info-circle",
      primary: "fas fa-bell",
      secondary: "fas fa-bell"
    };
    return icons[toastType] || icon;
  };

  return (
    <div className={`toast ${isVisible ? 'show' : ''} ${getToastClass(type)}`} style={{ minWidth: '300px' }}>
      <div className="toast-header border-0" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}>
        <i className={`${getIconByType(type)} me-2`}></i>
        <strong className="me-auto">{title}</strong>
        <button 
          type="button" 
          className="btn-close btn-close-white" 
          onClick={() => {
            setIsVisible(false);
            setTimeout(() => onClose(id), 300);
          }}
        ></button>
      </div>
      <div className="toast-body">
        {message}
      </div>
    </div>
  );
};

export default Toast;